"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ContactBar = require("./ContactBar");
Object.keys(_ContactBar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ContactBar[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ContactBar[key];
    }
  });
});